import { Identified } from "@/types/sdk-types";
import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import {
  GetAllClaimTemplateTypesEnum,
  RosTemplateControllerApi,
  RosTemplate,
} from "../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../../utils/utils";

interface NewTemplateListProps {
  pagination: DGT_Pagination;
  xTENANTID?: string;
  searchKey?: string;
  gridSorting?: GridSortItem[];
  specialityUuids?: Array<string>;
  templateType?: GetAllClaimTemplateTypesEnum | string;
  enabled?: boolean;
  archive?: boolean;
  appointmentUuid?: string;
}

/**
 * @author [Rajkumar Rathod]
 */
export function useNewTemplateList({
  pagination,
  xTENANTID,
  gridSorting,
  searchKey,
  specialityUuids,
  templateType,
  enabled = true,
  archive = false,
  appointmentUuid,
}: NewTemplateListProps): useBaseContent<Identified<RosTemplate>> {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey,
    prevPage,
  });
  const pageSize = getPageSize(searchKey, pagination);

  const sortData = gridSorting?.[0];

  return useQuery({
    queryKey: [
      "form-builder-list",
      pageSize,
      pageIndex,
      specialityUuids,
      searchKey,
      gridSorting,
      templateType,
      xTENANTID,
      archive,
      appointmentUuid,
    ],
    placeholderData: keepPreviousData,
    enabled: enabled,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new RosTemplateControllerApi(getConfigObject())
        .getAllClaim(
          pageIndex, //page
          pageSize, //pageSize
          sortData?.field ?? undefined, // sortBy
          sortData?.sort ?? undefined, // sortDirection
          specialityUuids, //speciality
          undefined, //status
          archive, //archive
          templateType
            ? (templateType.split(",") as GetAllClaimTemplateTypesEnum[])
            : undefined, //templateTypes
          searchKey,
          appointmentUuid ?? undefined, //appointmentUuid
          xTENANTID //xTENANTID
        )
        .then((res) => res?.data),
  });
}
